import React, { useCallback, useEffect, useState } from 'react';
import api from '../api';
import { SmtpStatus } from '../types';

const QUELLE_LABEL: Record<SmtpStatus['quelle'], string> = {
  db: 'Datenbank',
  env: 'Umgebungsvariablen (.env)',
  keine: 'keine',
};

const EinstellungenPage: React.FC = () => {
  const [quelle, setQuelle] = useState<SmtpStatus['quelle'] | null>(null);
  const [passwortGesetzt, setPasswortGesetzt] = useState(false);
  const [host, setHost] = useState('');
  const [port, setPort] = useState('');
  const [benutzer, setBenutzer] = useState('');
  const [absender, setAbsender] = useState('');
  const [passwort, setPasswort] = useState('');
  const [aktiv, setAktiv] = useState(false);
  const [fehler, setFehler] = useState('');
  const [meldung, setMeldung] = useState('');
  const [speichert, setSpeichert] = useState(false);

  const uebernehmen = (daten: SmtpStatus) => {
    setQuelle(daten.quelle);
    setPasswortGesetzt(daten.passwort_gesetzt);
    setHost(daten.host ?? '');
    setPort(daten.port !== null && daten.port !== undefined ? String(daten.port) : '');
    setBenutzer(daten.benutzer ?? '');
    setAbsender(daten.absender ?? '');
    setAktiv(daten.aktiv);
    // Das Passwort kommt nie vom Server — Feld bleibt/wird leer.
    setPasswort('');
  };

  const laden = useCallback(async () => {
    setFehler('');
    try {
      const res = await api.get<SmtpStatus>('/api/einstellungen/smtp');
      uebernehmen(res.data);
    } catch (err: any) {
      setFehler(err.response?.data?.detail || 'SMTP-Einstellungen konnten nicht geladen werden.');
    }
  }, []);

  useEffect(() => {
    laden();
  }, [laden]);

  const speichern = async (e: React.FormEvent) => {
    e.preventDefault();
    setSpeichert(true);
    setFehler('');
    setMeldung('');
    try {
      const res = await api.put<SmtpStatus>('/api/einstellungen/smtp', {
        host: host || null,
        port: port ? Number(port) : null,
        benutzer: benutzer || null,
        passwort: passwort || null,
        absender: absender || null,
        aktiv,
      });
      uebernehmen(res.data);
      setMeldung('SMTP-Einstellungen gespeichert.');
    } catch (err: any) {
      setFehler(err.response?.data?.detail || 'SMTP-Einstellungen konnten nicht gespeichert werden.');
    } finally {
      setSpeichert(false);
    }
  };

  return (
    <div className="k-seite">
      <div className="k-seite__kopf">
        <div>
          <span className="k-eyebrow">{'// fleet / einstellungen'}</span>
          <h1 className="k-h1">Einstellungen</h1>
        </div>
      </div>

      {fehler && <div className="k-fehler">{fehler}</div>}
      {meldung && <div className="k-meldung">{meldung}</div>}

      {quelle && (
        <dl className="k-fakten">
          <div className="k-fakt">
            <dt>Quelle</dt>
            <dd className="k-mono">{QUELLE_LABEL[quelle]}</dd>
          </div>
          <div className="k-fakt">
            <dt>Passwort gesetzt</dt>
            <dd className="k-mono">{passwortGesetzt ? 'ja' : 'nein'}</dd>
          </div>
        </dl>
      )}

      <form className="k-formular" onSubmit={speichern}>
        <div className="k-feld">
          <label>Host</label>
          <input value={host} onChange={e => setHost(e.target.value)} />
        </div>
        <div className="k-feld">
          <label>Port</label>
          <input
            type="number"
            value={port}
            onChange={e => setPort(e.target.value)}
          />
        </div>
        <div className="k-feld">
          <label>Benutzer</label>
          <input value={benutzer} onChange={e => setBenutzer(e.target.value)} />
        </div>
        <div className="k-feld">
          <label>Absender</label>
          <input value={absender} onChange={e => setAbsender(e.target.value)} />
        </div>
        <div className="k-feld">
          <label>Passwort</label>
          <input
            type="password"
            value={passwort}
            onChange={e => setPasswort(e.target.value)}
            placeholder="leer = unverändert"
          />
          <span className="k-feld__hint">
            Leer lassen, um das bestehende Passwort zu behalten. Beim erstmaligen
            Aktivieren der DB-Konfiguration bitte das Passwort neu eingeben — ein
            bestehendes .env-Passwort wird nicht übernommen.
          </span>
        </div>
        <div className="k-feld">
          <label>
            <input
              type="checkbox"
              checked={aktiv}
              onChange={e => setAktiv(e.target.checked)}
            />{' '}
            Diese Einstellungen aktiv verwenden
          </label>
          <span className="k-feld__hint">
            Nur wenn aktiv, werden diese Werte statt der Server-Umgebungsvariablen
            (.env) verwendet.
          </span>
        </div>
        <button className="k-btn" type="submit" disabled={speichert}>
          {speichert ? 'Wird gespeichert …' : 'Speichern'}
        </button>
      </form>
    </div>
  );
};

export default EinstellungenPage;
